import cx from "classnames";
import { CopyText } from "src/components/features/small/CopyText/CopyText";
import type {
  KeyValueItemLabelProps,
  KeyValueItemProps,
  KeyValueItemValueProps,
} from "./KeyValueItem.types";

const SCALE_CLASSNAME = "transition-all in-[.with-hover]:group-hover:scale-110";

const KeyValueItemLabel = ({ label, className }: KeyValueItemLabelProps) => (
  <div
    className={cx(
      "flex-1 text-text-secondary min-w-0 wrap-break-word leading-4 origin-left group-hover:text-text-primary",
      SCALE_CLASSNAME,
      className
    )}
  >
    {label}
  </div>
);

const KeyValueItemValue = ({
  children,
  className,
  withCopy,
}: KeyValueItemValueProps) => (
  <div
    className={cx(
      "flex-2 min-w-0 leading-4 origin-right wrap-anywhere",
      SCALE_CLASSNAME,
      className
    )}
  >
    {withCopy ? (
      <CopyText
        text={children + ""}
        className="-my-2 -ml-1"
        placeIconAtStart
        slotProps={{ iconButton: { edge: "start" } }}
      />
    ) : (
      children
    )}
  </div>
);

const KeyValueItem = ({
  label,
  children,
  className,
  withCopy,
  slotProps,
  dataTestId,
}: KeyValueItemProps) => (
  // Wrapper div needed to receive "key" prop when used in .map()
  // Hover styles use `in-[.with-hover]:` so they only apply when a parent
  // (e.g. KeyValueList with `withHover`) has the `with-hover` class — CSS-only, no prop here.
  <div
    data-test-id={dataTestId}
    className={cx(
      "flex items-start justify-between gap-x-4 rounded group in-[.with-hover]:hover:bg-action-hover",
      className
    )}
  >
    <KeyValueItemLabel label={label} className={className} {...slotProps?.label} />
    <KeyValueItemValue
      withCopy={withCopy}
      children={children}
      className={className}
      {...slotProps?.value}
    />
  </div>
);

export default KeyValueItem;
